
import { useEffect } from "react"
import { useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { getKayitliYukItem, getYukKaydiIsimleri, setIsFromKayitliYuk } from "../../../features/kayit/kayitSlice"
import { useSelector } from "react-redux"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import textFilter from "../../../helper/textFilter"
import {MdKeyboardArrowRight} from "react-icons/md"


const Container = styled.div`
    width: 500px;
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        padding-right: 30px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme, isActive}) => isActive? "#E85446" : theme.mainBorderColor};
        border-bottom: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        border-bottom-left-radius: ${({isActive}) => isActive && 0};
        border-bottom-right-radius: ${({isActive}) => isActive && 0};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};
        color: ${({theme}) => theme.mainTextColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }

    .arr-icon{
        position: absolute;
        right: 5px;
        top: 8px;
        transform: ${({isActive}) => isActive ? "rotate(90deg)": "rotate(0)"};
        font-size: 1.6rem;
        transition: .3s;
    }

    .options{
        position: absolute;
        top: 40px;
        background-color: ${({theme}) => theme.mainBgColor};
        display: flex;
        flex-direction: column;
        z-index: 10;
        width: 100%;
        border: 1px solid ${({theme, isActive}) => isActive? "#E85446" : theme.mainBorderColor};
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        max-height: 200px;
        overflow: auto;
        .option{
            width: 100%;
            padding: 9px 20px;
            cursor: pointer;


            &:hover{
                background-color: ${({theme}) => theme.secondaryBgColor};
            }
        }
    }
    @media (max-width: 1200px){
        width: 300px !important;
    }
`

const KayitliYuklerimInput = ({name="kayitliYukler", labelText="Kayıtlı Yüklerim", isRequired=false}) => {

    const [text, setText] = useState("")
    const dispatch = useDispatch()

    const {yukKaydiIsimleri} = useSelector(state => state.kayit)
    const {activeSelect} = useSelector(state => state.layout)

    const [options, setOptions] = useState([])

    useEffect(() => {
        if(yukKaydiIsimleri){
            setOptions(yukKaydiIsimleri)
        }
    },[yukKaydiIsimleri])
    useEffect(() => {
        dispatch(getYukKaydiIsimleri())
    },[dispatch])

    // dispatch(handleActiveSelect((activeSelect && activeSelect === name) ? null : name))
    
    const handleChange = (e) => {
        const searchText = e.target.value
        dispatch(handleActiveSelect(name))

        if(!searchText){
            setOptions(yukKaydiIsimleri)
            dispatch(handleActiveSelect(null))
        }

        else{
            const result = textFilter(yukKaydiIsimleri, searchText, "onKayitIsmi")
            setOptions(result)
        }
        setText(searchText)

    }

    const handleOptionClick = (item) => {

        setText(item.onKayitIsmi)
        dispatch(getKayitliYukItem(item?.id))
        dispatch(setIsFromKayitliYuk(true))
        dispatch(handleActiveSelect(null))

    }

    //! active olan item ın arka planını hafif sarı yaparsın

  return (
    <Container value={text} radius={"5px"} isActive={activeSelect === name}>

        <input type="text" id={"text"} onChange={handleChange} value={text} name={"text"} onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === name) ? null : name))} autoComplete="off"/> 
        <label htmlFor={"text"}>{labelText}</label>
        <MdKeyboardArrowRight className="arr-icon"/>
            {
                activeSelect === name &&
                <div className="options">
                    {
                        options.map((item) => (
                            <div key={item.id} className="option" onClick={() => handleOptionClick(item)}>
                                {item.onKayitIsmi || "DD"}
                            </div>
                        ))
                    }
                </div>
            }
    </Container>
  )
}

export default KayitliYuklerimInput
